
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { hospitalActions, userActions } from '../../../_actions';
import CloseIcon from '@mui/icons-material/Close';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function EditTreatementModel(props) {
let dispatch = useDispatch()
let selector = useSelector(state=>state)
console.log(props)
React.useEffect(()=>{
  dispatch(hospitalActions.SpecializationId());
},[])

    let {editopen,toggle,modelData} = props
  let [data,setData]=React.useState({})
 console.log(data)
    let [inputData,setinputData] = React.useState()

    const handleChange = (e) => {
      const { name, value } = e.target;
      setData({
        ...data,
        [name]: value,
      });
      console.log(JSON.parse(e.target.value),inputData)
    }

    React.useEffect(()=>{
      setData({...modelData,name:modelData?.name,id:modelData?.id})
    },[modelData])
   



    const [error, setError] = React.useState({
      title: '',
      name: '',
      mobNo: '',
      // specializationId: '',
      alternateNo: '',
      aboutUs: '',
      address: '',
      gmap: '',
    });



 let closeModel = ()=>{
  setError({
    title: '',
    name: '',
    mobNo: '',
    specializationId: '',
    alternateNo: '',
    aboutUs: '',
    address: '',
    gmap: '',
  })
  setinputData({})
  toggle();
 }


 const validateForm = () => {
  const newErrors = {};

  if (!inputData.name) {
    newErrors.name = 'Empty Field';
  }



  setError(newErrors);

  return Object.keys(newErrors).length === 0;
};









let submitDetails=()=>{ 
  console.log(data)
  let obj={
    "id":data?.id,
    "name":data?.name
  }
  dispatch(userActions.updatePhysioTreatement(obj))      
//   if(validateForm()){
//     // dispatch(userActions.addTreatment(data))      
// setError({
// title: '',
// name: '',
// mobNo: '',
// // specializationId: '',
// alternateNo: '',
// aboutUs: '',
// address: '',
// gmap: '',
// })
// setinputData({})
// closeModel()     


// }

}





  return (
    <div>
      <Modal
        open={editopen}
       
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>

 <div className='bg-[#005F60] rounded-md p-2 text-lg font-bold text-white flex justify-between'>
        <div >Edit Treatement</div>
        <CloseIcon onClick={closeModel} className=' cursor-pointer'/>

 </div>
        <form className="max-w-md mx-auto flex flex-col  mt-8 space-y-6">
        {/* <div>
  <label htmlFor="title" className="block text-sm font-medium text-gray-700">
    Title
  </label>
  <select
    id="title"
    name="title"
    className={`mt-1 p-2 w-full rounded-md border ${
      error.title ? 'border-red-500' : 'border-gray-300'
    } focus:outline-none focus:border-blue-500`}
    value={inputData?.title}
    onChange={handleChange}
  >
    <option value="">Select Title</option>
    <option value="Dr.">Dr.</option>
    <option value="Mr.">Mr.</option>
    <option value="Mrs.">Mrs.</option>
    <option value="Ms.">Ms.</option>

  </select>
  {error['title'] && <p className='text-sm text-red-500'>{error.title}</p>}
</div> */}










         <div>
    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
      Treatement 
    </label>
    <input
      id="name"
      name="name"
      type="text"
      placeholder="Write Treatement"
      className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
      value={data?.name || ''}
      onChange={(e)=>handleChange(e)}
    />
    {error['name'] && <p className='text-sm text-red-500'>{error.name}</p>}
         </div>

  


  
{/* 
         <div>
    <label htmlFor="mobNo" className="block text-sm font-medium text-gray-700">
     Mobile Number
    </label>
    <input
      id="mobNo"
      name="mobNo"
      type="text"
      placeholder="Enter About Us"
      className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
      value={inputData?.mobNo || ''}
      onChange={(e)=>handleChange(e)}
    />
    {error['mobNo'] && <p className='text-sm text-red-500'>{error.mobNo}</p>}
         </div> */}

         {/* <div>
  <label htmlFor="specializationId" className="block text-sm font-medium text-gray-700">
    SpecializationId
  </label>
  <select
    id="specializationId"
    name="specializationId"
    className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
    value={inputData?.specializationId}
    onChange={handleChange}
  >
    <option value="">Select Title</option>
    {selector?.hospital?.specializationid?.SpecializationId.map((e) => {
      console.log(e)
      return(
        <option key={e.id} value={e.id}>{e?.name}</option>
      )
    })}

 
   
  </select>
  {error['specializationId'] && <p className='text-sm text-red-500'>{error.specializationId}</p>}
</div> */}


         <div className='flex'>










{/* 
<div>
<label htmlFor="alternateNo" className="block text-sm font-medium text-gray-700">
Alternate Number
</label>
<input
id="alternateNo"
name="alternateNo"
type="text"
placeholder="Enter About Us"
className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
value={inputData?.alternateNo || ''}
onChange={(e)=>handleChange(e)}
/>
{error['alternateNo'] && <p className='text-sm text-red-500'>{error.alternateNo}</p>}
 </div> */}


{/* 
 <div>
<label htmlFor="aboutUs" className="block text-sm font-medium text-gray-700">
About us
</label>
<input
id="aboutUs"
name="aboutUs"
type="text"
placeholder="Enter About Us"
className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
value={inputData?.aboutUs || ''}
onChange={(e)=>handleChange(e)}
/>
{error['aboutUs'] && <p className='text-sm text-red-500'>{error.aboutUs}</p>}
 </div> */}



</div>


{/* 
<div className='flex'>

 <div>
<label htmlFor="address" className="block text-sm font-medium text-gray-700">
address
</label>
<input
id="address"
name="address"
type="text"
placeholder="Enter About Us"
className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
value={inputData?.address || ''}
onChange={(e)=>handleChange(e)}
/>
{error['address'] && <p className='text-sm text-red-500'>{error.address}</p>}
 </div>

 <div>
<label htmlFor="gmap" className="block text-sm font-medium text-gray-700">
Map Link
</label>
<input
id="gmap"
name="gmap"
type="text"
placeholder="Enter About Us"
className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
value={inputData?.gmap || ''}
onChange={(e)=>handleChange(e)}
/>
{error['gmap'] && <p className='text-sm text-red-500'>{error.gmap}</p>}
 </div>

</div> */}




<button
  onClick={submitDetails}
  type="button"
  className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#005F60] hover:bg-[#005F40] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
>
  Submit
</button>

</form>
        </Box>
      </Modal>
    </div>
  );
}










